import moment from 'moment';
import dummy1 from '../Assets/dummy1.jpg';
import dummy2 from '../Assets/dummy2.jpg';
import dummy3 from '../Assets/dummy3.jpg';

export const calculateTotal = (tableData) => {
  let total = 0;
  for (const data of tableData) {
    if (data.item === 'Coupon Discount') {
      total -= data.total;
    } else {
      total += data.total;
    }
  }
  return total;
};

export const capitalize = (s) => s && s[0]?.toUpperCase() + s?.slice(1);

export const handleTicketCheckBox = (checkedItems, setCheckedItems, id) => {
  if (checkedItems.includes(id)) {
    const temp = [...checkedItems];
    const indexOfElement = checkedItems.indexOf(id);
    temp.splice(indexOfElement, 1);
    setCheckedItems(temp);
  } else {
    const temp = [...checkedItems];
    temp.push(id);
    setCheckedItems(temp);
  }
};

export const handleBooking = async (e, setOpenModal, modalConfig) => {
  try {
    setOpenModal({ open: true, config: modalConfig.success });
  } catch {
    setOpenModal({ open: true, config: modalConfig.failure });
  }
};

export const dynamicImageRender = (index) => {
  console.log('index', index);
  switch (index) {
    case 0:
      return dummy1;
    case 1:
      return dummy2;
    case 2:
      return dummy3;
    default:
      return dummy1;
  }
};

export function getMonthAbbreviation(monthNumber) {
  if (monthNumber < 1 || monthNumber > 12) {
    return 'Invalid month number';
  }
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  return months[monthNumber - 1];
}
export const dateFormatter = (startDate, endDate, card) => {
  const formattedStartTime = moment(startDate).format('hh:mm A');
  const formattedEndTime = moment(endDate).format('hh:mm A');

  const startMonth = getMonthAbbreviation(moment(startDate).format('MM'));
  const startDay = moment(startDate).format('DD');
  const endDay = moment(endDate).format('DD');
  if (card) {
    return `${startMonth} ${startDay} - ${endDay}, ${formattedStartTime} - ${formattedEndTime}`;
  } else {
    return `${startMonth}  ${startDay}, ${formattedStartTime}`;
  }
};
export const dateFormatterForCoupon = (startDate) => {
  const startDay = moment(startDate).format('DD');
  const startMonth = getMonthAbbreviation(moment(startDate).format('MM'));
  const startYear = moment(startDate).format('YYYY');

  // const startYear = getMonthAbbreviation(moment(startDate).format("YY"));

  return `${startDay}th ${startMonth} ${startYear}`;
};

export const getFilterDate = (type) => {
  let desiredDate = '';
  if (type === 'Today') {
    desiredDate = Date.now();
  } else {
    const tempDate = new Date();
    desiredDate = tempDate.setDate(tempDate.getDate() + 1);
  }

  const formattedDate = moment(desiredDate).format('DD MMM YYYY');
  return `${formattedDate}`;
};

export const findMinimumPrice = (tickets) => {
  console.log('findMinimumPrice', tickets);
  if (!Array.isArray(tickets) || tickets.length === 0) {
    return null; // Return null if the input is not a valid array or is empty
  }

  return tickets.reduce((min, ticket) => {
    return ticket.price < min ? ticket.price : min;
  }, Infinity);
};
